import { motion } from 'framer-motion'
import ScrollReveal from '../components/shared/ScrollReveal'
import GradientText from '../components/shared/GradientText'
import GlowButton from '../components/shared/GlowButton'
import './DraftPages.css'

const Icons = {
  layers: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polygon points="12 2 2 7 12 12 22 7 12 2" />
      <polyline points="2 17 12 22 22 17" />
      <polyline points="2 12 12 17 22 12" />
    </svg>
  ),
  cpu: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <rect x="9" y="9" width="6" height="6" />
      <line x1="9" y1="1" x2="9" y2="4" />
      <line x1="15" y1="1" x2="15" y2="4" />
      <line x1="9" y1="20" x2="9" y2="23" />
      <line x1="15" y1="20" x2="15" y2="23" />
      <line x1="20" y1="9" x2="23" y2="9" />
      <line x1="20" y1="14" x2="23" y2="14" />
      <line x1="1" y1="9" x2="4" y2="9" />
      <line x1="1" y1="14" x2="4" y2="14" />
    </svg>
  ),
  database: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <ellipse cx="12" cy="5" rx="9" ry="3" />
      <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" />
      <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
    </svg>
  ),
  globe: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  ),
  shield: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  zap: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
    </svg>
  ),
  code: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="16 18 22 12 16 6" />
      <polyline points="8 6 2 12 8 18" />
    </svg>
  ),
  server: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="2" y="2" width="20" height="8" rx="2" ry="2" />
      <rect x="2" y="14" width="20" height="8" rx="2" ry="2" />
      <line x1="6" y1="6" x2="6.01" y2="6" />
      <line x1="6" y1="18" x2="6.01" y2="18" />
    </svg>
  ),
  cloud: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
    </svg>
  ),
  smartphone: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
      <line x1="12" y1="18" x2="12.01" y2="18" />
    </svg>
  ),
  check: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  link: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </svg>
  ),
  users: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  eye: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  tool: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
    </svg>
  ),
  settings: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  ),
  activity: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
    </svg>
  ),
  key: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />
    </svg>
  )
}

const platformStats = [
  { value: '110+', label: 'Components', description: 'Modular architecture' },
  { value: '170+', label: 'API Endpoints', description: 'RESTful services' },
  { value: '90+', label: 'Database Tables', description: 'PostgreSQL schemas' },
  { value: '97%', label: 'Code Complete', description: 'Production ready' }
]

const architectureLayers = [
  {
    name: 'Presentation Layer',
    icon: Icons.smartphone,
    color: 'var(--color-solar)',
    technologies: ['React 18', 'React Native', 'Framer Motion', 'TailwindCSS'],
    description: 'Responsive web dashboard and native mobile apps for iOS and Android'
  },
  {
    name: 'API Gateway',
    icon: Icons.server,
    color: 'var(--color-energy)',
    technologies: ['Node.js', 'Express', 'WebSocket', 'JWT Auth'],
    description: 'RESTful APIs with real-time WebSocket connections for live data'
  },
  {
    name: 'Intelligence Layer',
    icon: Icons.cpu,
    color: 'var(--color-drone)',
    technologies: ['Python', 'TensorFlow', 'PyTorch', 'YOLOv8'],
    description: '6 ML models fusing ground, drone, and satellite data for predictive maintenance'
  },
  {
    name: 'Data Layer',
    icon: Icons.database,
    color: 'var(--color-alert)',
    technologies: ['PostgreSQL', 'TimescaleDB', 'Redis', 'S3'],
    description: 'Time-series optimized storage with caching and object storage'
  }
]

const integrations = [
  {
    category: 'Inverter Systems',
    icon: Icons.zap,
    items: [
      { name: 'Fronius', protocol: 'Modbus TCP', status: 'Production' },
      { name: 'SMA', protocol: 'Modbus TCP', status: 'Production' },
      { name: 'Huawei', protocol: 'SDongle Push', status: 'Production' },
      { name: 'SolarEdge', protocol: 'REST API', status: 'Roadmap' }
    ]
  },
  {
    category: 'Satellite & Imaging',
    icon: Icons.globe,
    items: [
      { name: 'NASA POWER', protocol: 'REST API', status: 'Production' },
      { name: 'Copernicus', protocol: 'REST API', status: 'Production' },
      { name: 'Drone Thermal', protocol: 'Image Upload', status: 'Production' },
      { name: 'EL Imaging', protocol: 'Image Upload', status: 'Production' }
    ]
  },
  {
    category: 'Weather & Environmental',
    icon: Icons.globe,
    items: [
      { name: 'Open-Meteo', protocol: 'REST API', status: 'Production' },
      { name: 'Weather Maps', protocol: 'Tile API', status: 'Production' },
      { name: 'Environmental Sensors', protocol: 'Modbus/IoT', status: 'Production' }
    ]
  },
  {
    category: 'Data Export',
    icon: Icons.cloud,
    items: [
      { name: 'CSV Export', protocol: 'Download', status: 'Production' },
      { name: 'JSON API', protocol: 'REST API', status: 'Production' },
      { name: 'Webhooks', protocol: 'Push', status: 'Production' }
    ]
  }
]

const securityFeatures = [
  { name: 'End-to-End Encryption', description: 'TLS 1.3 for all data in transit' },
  { name: 'Role-Based Access', description: 'Granular permissions per user and site' },
  { name: 'Audit Logging', description: 'Complete trail of all system actions' },
  { name: 'GDPR Compliant', description: 'EU data protection standards' },
  { name: 'ISO 27001', description: 'Information security management' },
  { name: 'SOC 2 Type II', description: 'Security and availability controls' }
]

const performanceMetrics = [
  { metric: 'API Response', value: '<100ms', description: '95th percentile' },
  { metric: 'Uptime SLA', value: '99.9%', description: 'Guaranteed availability' },
  { metric: 'Data Latency', value: '<5s', description: 'Sensor to dashboard' },
  { metric: 'Concurrent Users', value: '10,000+', description: 'Per deployment' }
]

const userRoles = [
  {
    name: 'Viewer',
    level: 1,
    icon: Icons.eye,
    color: 'var(--color-gray-400)',
    description: 'Read-only access to dashboards and reports',
    capabilities: ['View performance dashboards', 'Access monitoring data', 'View alert history', 'Basic reports']
  },
  {
    name: 'Technician',
    level: 2,
    icon: Icons.tool,
    color: 'var(--color-drone)',
    description: 'Field diagnostics and inspection capabilities',
    capabilities: ['Fault detection access', 'EL image viewer', 'Drone operations', 'Thermal analysis']
  },
  {
    name: 'Operator',
    level: 3,
    icon: Icons.activity,
    color: 'var(--color-energy)',
    description: 'Operational control and alert management',
    capabilities: ['Configure alerts', 'Manage workforce', 'DC I/U analysis', 'Operational reports']
  },
  {
    name: 'Engineer',
    level: 4,
    icon: Icons.cpu,
    color: 'var(--color-solar)',
    description: 'Advanced diagnostics and analytics',
    capabilities: ['Component diagnostics', 'Performance analysis', 'String sizing', 'Chronic issues tracking']
  },
  {
    name: 'Integrator',
    level: 5,
    icon: Icons.settings,
    color: 'var(--color-alert)',
    description: 'System setup and configuration',
    capabilities: ['Setup wizard access', 'Site management', 'Inverter configuration', 'Customer user management']
  },
  {
    name: 'Admin',
    level: 6,
    icon: Icons.key,
    color: '#ff6b6b',
    description: 'Full system control and user management',
    capabilities: ['User & role management', 'License management', 'Permission assignment', 'Full system access']
  }
]

const languages = [
  'English', 'German', 'Greek', 'Spanish', 'French',
  'Italian', 'Dutch', 'Polish', 'Portuguese', 'Romanian'
]

export default function Platform() {
  return (
    <div className="draft-page platform-page">
      {/* Hero Section */}
      <section className="draft-hero platform-hero">
        <div className="container">
          <ScrollReveal>
            <span className="draft-badge">Monitoring + Predictive Intelligence</span>
          </ScrollReveal>
          <ScrollReveal delay={0.1}>
            <h1 className="draft-title">
              One Platform.{' '}
              <GradientText gradient="space">Multi-Source Intelligence.</GradientText>
            </h1>
          </ScrollReveal>
          <ScrollReveal delay={0.2}>
            <p className="draft-subtitle">
              Ground sensors, drone thermal, and satellite data fused into a single predictive platform.
              Not just monitoring—intelligent operations management built for solar at scale.
            </p>
          </ScrollReveal>

          {/* Platform Stats */}
          <ScrollReveal delay={0.3}>
            <div className="platform-hero-stats">
              {platformStats.map((stat, i) => (
                <motion.div
                  key={i}
                  className="platform-hero-stat"
                  whileHover={{ y: -5, scale: 1.02 }}
                  transition={{ type: 'spring', stiffness: 300 }}
                >
                  <span className="phs-value">{stat.value}</span>
                  <span className="phs-label">{stat.label}</span>
                  <span className="phs-desc">{stat.description}</span>
                </motion.div>
              ))}
            </div>
          </ScrollReveal>
        </div>
      </section>

      {/* Platform Preview */}
      <section className="platform-section">
        <div className="container">
          <ScrollReveal className="section-header">
            <h2>The Dashboard Experience</h2>
            <p>Designed for solar professionals who need actionable insights, not data overload</p>
          </ScrollReveal>

          <ScrollReveal delay={0.1}>
            <motion.div
              style={{
                borderRadius: 'var(--radius-xl)',
                overflow: 'hidden',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                boxShadow: '0 25px 80px rgba(0, 0, 0, 0.6)',
                marginBottom: 'var(--space-3xl)'
              }}
              whileHover={{ scale: 1.01 }}
              transition={{ duration: 0.3 }}
            >
              <img
                src="/images/platform/energy-forecasting-dark.png"
                alt="AI4Solar Energy Forecasting Dashboard"
                style={{ width: '100%', height: 'auto', display: 'block' }}
              />
            </motion.div>
          </ScrollReveal>

          <ScrollReveal delay={0.2}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: 'var(--space-lg)',
              textAlign: 'center'
            }}>
              <div style={{ padding: 'var(--space-lg)' }}>
                <span style={{ color: 'var(--color-solar)', fontSize: '1.5rem', fontWeight: 700 }}>Dark & Light</span>
                <p style={{ color: 'var(--color-gray-400)', fontSize: '0.875rem', marginTop: '0.5rem' }}>Modes for any environment</p>
              </div>
              <div style={{ padding: 'var(--space-lg)' }}>
                <span style={{ color: 'var(--color-energy)', fontSize: '1.5rem', fontWeight: 700 }}>10 Languages</span>
                <p style={{ color: 'var(--color-gray-400)', fontSize: '0.875rem', marginTop: '0.5rem' }}>Full localization support</p>
              </div>
              <div style={{ padding: 'var(--space-lg)' }}>
                <span style={{ color: 'var(--color-drone)', fontSize: '1.5rem', fontWeight: 700 }}>110+ Components</span>
                <p style={{ color: 'var(--color-gray-400)', fontSize: '0.875rem', marginTop: '0.5rem' }}>Modular dashboard system</p>
              </div>
              <div style={{ padding: 'var(--space-lg)' }}>
                <span style={{ color: 'var(--color-satellite)', fontSize: '1.5rem', fontWeight: 700 }}>28 Views</span>
                <p style={{ color: 'var(--color-gray-400)', fontSize: '0.875rem', marginTop: '0.5rem' }}>3-level navigation</p>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>

      {/* Architecture Layers */}
      <section className="platform-section">
        <div className="container">
          <ScrollReveal className="section-header">
            <h2>Layered Architecture</h2>
            <p>Clean separation of concerns for maintainability and scalability</p>
          </ScrollReveal>

          <div className="architecture-stack">
            {architectureLayers.map((layer, i) => (
              <ScrollReveal key={i} delay={i * 0.1}>
                <motion.div
                  className="architecture-layer"
                  whileHover={{ x: 10 }}
                  style={{ '--layer-color': layer.color }}
                >
                  <div className="layer-icon">{layer.icon}</div>
                  <div className="layer-content">
                    <h3 className="layer-name">{layer.name}</h3>
                    <p className="layer-description">{layer.description}</p>
                    <div className="layer-tech">
                      {layer.technologies.map((tech, j) => (
                        <span key={j} className="tech-pill">{tech}</span>
                      ))}
                    </div>
                  </div>
                </motion.div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>

      {/* Integrations */}
      <section className="platform-section platform-dark">
        <div className="container">
          <ScrollReveal className="section-header">
            <h2>Hardware &amp; Data Integrations</h2>
            <p>Direct connections to leading solar equipment and data providers</p>
          </ScrollReveal>

          <div className="integrations-grid">
            {integrations.map((category, i) => (
              <ScrollReveal key={i} delay={i * 0.1}>
                <div className="integration-category">
                  <div className="ic-header">
                    <div className="ic-icon">{category.icon}</div>
                    <h3>{category.category}</h3>
                  </div>
                  <div className="ic-items">
                    {category.items.map((item, j) => (
                      <div key={j} className="ic-item">
                        <div className="ic-item-info">
                          <span className="ic-name">{item.name}</span>
                          <span className="ic-protocol">{item.protocol}</span>
                        </div>
                        <span className={`ic-status ic-status-${item.status.toLowerCase()}`}>
                          {item.status}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>

      {/* Performance Metrics */}
      <section className="platform-section">
        <div className="container">
          <ScrollReveal className="section-header">
            <h2>Performance Guaranteed</h2>
            <p>Enterprise SLAs backed by robust infrastructure</p>
          </ScrollReveal>

          <div className="performance-grid">
            {performanceMetrics.map((item, i) => (
              <ScrollReveal key={i} delay={i * 0.1}>
                <motion.div
                  className="performance-card"
                  whileHover={{ y: -5 }}
                >
                  <span className="perf-value">{item.value}</span>
                  <span className="perf-metric">{item.metric}</span>
                  <span className="perf-desc">{item.description}</span>
                </motion.div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>

      {/* Security */}
      <section className="platform-section platform-dark">
        <div className="container">
          <div className="security-grid">
            <ScrollReveal className="security-content">
              <div className="security-icon">{Icons.shield}</div>
              <h2>Enterprise Security</h2>
              <p>
                Your data is protected by industry-leading security measures.
                From encryption in transit to comprehensive audit logging,
                we take security seriously.
              </p>
            </ScrollReveal>

            <ScrollReveal delay={0.2}>
              <div className="security-features">
                {securityFeatures.map((feature, i) => (
                  <motion.div
                    key={i}
                    className="security-feature"
                    whileHover={{ x: 5 }}
                  >
                    <div className="sf-check">{Icons.check}</div>
                    <div className="sf-content">
                      <span className="sf-name">{feature.name}</span>
                      <span className="sf-desc">{feature.description}</span>
                    </div>
                  </motion.div>
                ))}
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* Role-Based Access Control */}
      <section className="platform-section">
        <div className="container">
          <ScrollReveal className="section-header">
            <h2>Role-Based Access Control</h2>
            <p>6-level permission hierarchy ensures the right people have the right access</p>
          </ScrollReveal>

          <div className="roles-grid">
            {userRoles.map((role, i) => (
              <ScrollReveal key={i} delay={i * 0.1}>
                <motion.div
                  className="role-card"
                  style={{ '--role-color': role.color }}
                  whileHover={{ y: -5, scale: 1.02 }}
                >
                  <div className="role-header">
                    <div className="role-icon">{role.icon}</div>
                    <div className="role-level">Level {role.level}</div>
                  </div>
                  <h3 className="role-name">{role.name}</h3>
                  <p className="role-description">{role.description}</p>
                  <ul className="role-capabilities">
                    {role.capabilities.map((cap, j) => (
                      <li key={j}>
                        <span className="cap-check">{Icons.check}</span>
                        {cap}
                      </li>
                    ))}
                  </ul>
                </motion.div>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal delay={0.3}>
            <div className="roles-note">
              <p>
                <strong>Hierarchical permissions:</strong> Each role inherits all capabilities from lower levels.
                An Engineer has access to everything a Technician can do, plus advanced analytics.
              </p>
            </div>
          </ScrollReveal>
        </div>
      </section>

      {/* Languages */}
      <section className="platform-section platform-dark">
        <div className="container">
          <ScrollReveal className="section-header">
            <h2>10 Languages Supported</h2>
            <p>Full localization for pan-European deployment</p>
          </ScrollReveal>

          <ScrollReveal delay={0.1}>
            <div className="languages-grid">
              {languages.map((lang, i) => (
                <motion.div
                  key={i}
                  className="language-pill"
                  whileHover={{ scale: 1.05 }}
                >
                  {lang}
                </motion.div>
              ))}
            </div>
          </ScrollReveal>
        </div>
      </section>

      {/* API Documentation Preview */}
      <section className="platform-section platform-dark">
        <div className="container">
          <div className="api-preview-grid">
            <ScrollReveal className="api-content">
              <span className="draft-badge">Developer Friendly</span>
              <h2>Comprehensive API</h2>
              <p>
                170+ RESTful endpoints with full OpenAPI documentation.
                Real-time WebSocket streams for live data.
                OAuth 2.0 authentication with granular scopes.
              </p>
              <div className="api-features">
                <div className="api-feature">
                  <span className="af-icon">{Icons.code}</span>
                  <span>OpenAPI 3.0 Spec</span>
                </div>
                <div className="api-feature">
                  <span className="af-icon">{Icons.zap}</span>
                  <span>WebSocket Streams</span>
                </div>
                <div className="api-feature">
                  <span className="af-icon">{Icons.shield}</span>
                  <span>OAuth 2.0 Auth</span>
                </div>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={0.2}>
              <div className="code-preview">
                <div className="code-header">
                  <span className="code-dot red"></span>
                  <span className="code-dot yellow"></span>
                  <span className="code-dot green"></span>
                  <span className="code-filename">api-example.js</span>
                </div>
                <pre className="code-body">
{`// Get real-time production data
const response = await fetch(
  'https://api.ai4solar.com/v1/sites/{siteId}/production',
  {
    headers: {
      'Authorization': 'Bearer {token}',
      'Content-Type': 'application/json'
    }
  }
);

const data = await response.json();
// {
//   "power": 4.2,
//   "energy_today": 28.5,
//   "efficiency": 0.94,
//   "status": "optimal"
// }`}
                </pre>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="draft-cta">
        <div className="container">
          <ScrollReveal className="draft-cta-content">
            <h2>Ready to integrate?</h2>
            <p>Talk to our engineering team about your technical requirements and integration needs.</p>
            <div className="cta-buttons">
              <GlowButton href="/demo" variant="solar" size="large">
                Request API Access
              </GlowButton>
              <GlowButton href="/features" variant="outline" size="large">
                Explore Features
              </GlowButton>
            </div>
          </ScrollReveal>
        </div>
      </section>
    </div>
  )
}
